import type { WizardFarm } from '../../types/farmWizard'

import { registerFarmTimeZones } from '../../utils/farmTime'
import { getOfflineDb } from '../dbFactory'
import type { FarmRepo } from './FarmRepo'

// Findings #85: every read / write of farms keeps the farm time-zone registry
// current, so day keys for a record's `farmId` use the farm's own zone.
export class DexieFarmRepo implements FarmRepo {
  async list(): Promise<WizardFarm[]> {
    const farms = await getOfflineDb().farms.orderBy('name').toArray()
    registerFarmTimeZones(farms)
    return farms
  }

  async getById(id: string): Promise<WizardFarm | undefined> {
    const farm = await getOfflineDb().farms.get(id)
    if (farm) registerFarmTimeZones([farm])
    return farm
  }

  async upsert(farm: WizardFarm): Promise<void> {
    await getOfflineDb().farms.put(farm)
    registerFarmTimeZones([farm])
  }

  async upsertMany(farms: WizardFarm[]): Promise<void> {
    if (farms.length === 0) return
    await getOfflineDb().farms.bulkPut(farms)
    registerFarmTimeZones(farms)
  }

  async replaceAll(farms: WizardFarm[]): Promise<void> {
    const db = getOfflineDb()
    await db.transaction('rw', db.farms, async () => {
      await db.farms.clear()
      if (farms.length > 0) {
        await db.farms.bulkPut(farms)
      }
    })
    registerFarmTimeZones(farms)
  }

  async delete(id: string): Promise<void> {
    await getOfflineDb().farms.delete(id)
  }

  async clear(): Promise<void> {
    await getOfflineDb().farms.clear()
  }
}

export const dexieFarmRepo = new DexieFarmRepo()
